// frontend/src/components/engineer/components/ValidationStatusBadge.tsx
import React from 'react';
import { ClockIcon, CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { getValidationStatusInfo, isValidationPending } from '../../../utils/overtimeValidation.utils';

interface ValidationStatusBadgeProps {
  request: any;
  showDetails?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const ValidationStatusBadge: React.FC<ValidationStatusBadgeProps> = ({ 
  request, 
  showDetails = false,
  size = 'md'
}) => {
  const info = getValidationStatusInfo(request);
  
  const sizeStyles = {
    sm: {
      padding: '0.375rem 0.75rem',
      fontSize: '0.75rem',
      iconSize: '1rem',
      gap: '0.375rem'
    },
    md: {
      padding: '0.5rem 1rem',
      fontSize: '0.8125rem',
      iconSize: '1.125rem',
      gap: '0.5rem'
    },
    lg: {
      padding: '0.75rem 1.25rem',
      fontSize: '0.875rem',
      iconSize: '1.25rem',
      gap: '0.625rem'
    }
  };

  const currentSize = sizeStyles[size];

  const getIcon = () => {
    const iconStyle = { width: currentSize.iconSize, height: currentSize.iconSize };
    
    switch (info.status) {
      case 'pending_validation':
        return <ClockIcon style={iconStyle} />;
      case 'validated_complete':
        return <CheckCircleIcon style={iconStyle} />;
      case 'validated_partial':
        return <ExclamationTriangleIcon style={iconStyle} />;
      case 'validated_failed':
        return <XCircleIcon style={iconStyle} />;
      default:
        return <ClockIcon style={iconStyle} />;
    }
  };

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: currentSize.gap,
      padding: currentSize.padding,
      background: info.bgColor,
      color: info.color,
      borderRadius: '0.5rem',
      fontSize: currentSize.fontSize,
      fontWeight: '600',
      border: `1px solid ${info.color}20`
    }}>
      {getIcon()}
      <span>{info.icon} {showDetails ? info.message : info.status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</span>
    </div>
  );
};

export default ValidationStatusBadge;